import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import {
  KnockOrderItemType,
  PRODUCT_TYPE_DELIVERY,
  PRODUCT_TYPE_RENTAL_SMS,
} from '../../controller/OrderController';
import { getStatusTypeList, getStoreTypeStatus } from '../../screens/SalesManager/StatusComment';
import '../../styles/CustomModal.css';
import { formatPhoneNumber } from '../../utils/util';
import { ORDER_CANCLE_STATUS } from '../../utils/DataType';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  order: KnockOrderItemType;
  isMobile: boolean;
  updateStatus: any;
  cancelStatus: any;
  setVisibleReject: any;
  checkProgress: any;
};

const SaleDetailModal = ({
  isVisible,
  setVisible,
  order,
  isMobile,
  updateStatus,
  cancelStatus,
  setVisibleReject,
  checkProgress,
}: Props) => {
  const [statusType, setStatusType] = useState<number[]>([]);

  const onCloseModal = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (order) {
      setStatusType(getStatusTypeList(order.child.order_category));
    }
  }, [order]);

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: 'saleDetailModalOverlay',
        modal: 'saleDetailModal',
        root: 'customModalRoot',
      }}
      showCloseIcon={!isMobile}
      animationDuration={150}>
      <Style>
        <div className="modalWrapper">
          <div>
            <div className="modalTitle">
              {isMobile && (
                <img
                  onClick={() => setVisible(false)}
                  className="closeIcon"
                  src={`${process.env.PUBLIC_URL}/svg/ic_back_bold.svg`}
                  alt="back"
                />
              )}
              <div className="headerBar" />
              <h2>{isMobile ? '주문 내역' : '상세내역'}</h2>
            </div>
            <div className="modalBody">
              <div className="modalContent">
                <div className="prdWrap">
                  <h4 className="title">상품명</h4>
                  <div style={{ width: '100%' }}>
                    {order.child.detail.map((item, index) => (
                      <div key={index} className="menuWrap">
                        <div className="between">
                          <h3 className="prdName">{item.product_name}</h3>
                          <h3 className="prdQuantity">{item.product_quantity}</h3>
                          <h3 className="prdPrice">
                            {item.product_total_amount.toLocaleString()}원
                          </h3>
                        </div>
                        {item.set_prd_type_list.map((set, setIndex: number) => {
                          return (
                            <div key={setIndex}>
                              {set.set_product.map((setPrd, setPrdIndex: number) => {
                                const getOptionName = () => {
                                  const optionNames = setPrd.options.map(
                                    (option) => option.option_name,
                                  );
                                  return optionNames.join(', ');
                                };
                                return (
                                  <div className="between" key={setPrdIndex}>
                                    <h4>
                                      <span>
                                        <img
                                          src={`${process.env.PUBLIC_URL}/svg/ic_linebreak_black.svg`}
                                          alt="img"
                                        />
                                      </span>
                                      [세트] {setPrd.product_name}
                                    </h4>
                                    <div className="row option">
                                      <h5>{getOptionName()}</h5>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                        {item.options.map((option, optionIndex: number) => {
                          return (
                            <div className="between" key={optionIndex}>
                              <h4>
                                <span>
                                  <img
                                    src={`${process.env.PUBLIC_URL}/svg/ic_linebreak_black.svg`}
                                    alt="img"
                                  />
                                </span>
                                [옵션] {option.option_name}
                              </h4>
                              <h4>{option.option_price.toLocaleString()}원</h4>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                  {order.child.delivery_tip > 0 && (
                    <div className="menuWrap">
                      <div className="between">
                        <h3 className="prdName">배달팁</h3>
                        <h3 className="prdPrice">{order.child.delivery_tip.toLocaleString()}원</h3>
                      </div>
                    </div>
                  )}
                  {/* {order.child.room_tip > 0 && (
                    <div className="menuWrap">
                      <div className="between">
                        <h3 className="prdName">객실관리팁</h3>
                        <h3 className="prdPrice">{order.child.room_tip.toLocaleString()}원</h3>
                      </div>
                    </div>
                  )} */}
                </div>
              </div>
              <div className="areaLine" />
              <div className="modalContent">
                <div className="row gap">
                  <h4 className="subtitle">접수시간</h4>
                  <h3>{moment(order.child.ordered_at).format('YYYY-MM-DD')}</h3>
                  <h3>{moment(order.child.ordered_at).format('HH:mm')}</h3>
                </div>
                {/* <div className="row gap">
              <h4 className="subtitle">대여시간</h4>

              <h3>{moment(order.child.ordered_at).format('YYYY-MM-DD')}</h3>
              <h3>{moment(order.child.ordered_at).format('HH:mm')}</h3>
            </div> */}
                <div className="row gap">
                  <h4 className="subtitle">객실</h4>
                  <h3>{order.child.delivery_address_detail}</h3>
                </div>
                <div className="row gap">
                  <h4 className="subtitle">거래금액</h4>
                  <h3>{order.child.total_amount_org.toLocaleString()}원</h3>
                </div>
                {order.child.discount_amount > 0 && (
                  <div className="row gap">
                    <h4 className="subtitle">할인금액</h4>
                    <h3>{order.child.discount_amount.toLocaleString()}원</h3>
                  </div>
                )}
                <div className="row gap">
                  <h4 className="subtitle">결제금액</h4>
                  <h3>{order.child.total_amount_incl.toLocaleString()}원</h3>
                </div>
                <div className="row gap">
                  <h4 className="subtitle">결제상태</h4>
                  <h3>{order.child.payment_status === 0 ? '미결제' : '완료'}</h3>
                </div>
                {order.child.order_category === PRODUCT_TYPE_DELIVERY && (
                  <div className="row gap">
                    <h4 className="subtitle">주소</h4>
                    <h3>{order.child.delivery_address}</h3>
                  </div>
                )}
                <div className="row gap">
                  <h4 className="subtitle">연락처</h4>
                  <h3>{order.child.store_phone_number}</h3>
                </div>
                {order.child.order_category === PRODUCT_TYPE_DELIVERY && (
                  <div className="row gap">
                    <h4 className="subtitle">호텔전화</h4>
                    <h3>{order.child.hotel_phone_number}</h3>
                  </div>
                )}
                {order.child.order_category === PRODUCT_TYPE_RENTAL_SMS && (
                  <div className="row gap">
                    <h4 className="subtitle">고객 연락처</h4>
                    <h3>
                      {order.child.order_check_type === 1 && order.child.customer_phone_number
                        ? formatPhoneNumber(order.child.customer_phone_number)
                        : order.child.email}
                    </h3>
                  </div>
                )}
                <div className="statusBarWrap">
                  <div className="statusBar">
                    <div
                      className="progressBar"
                      style={{
                        width: `${
                          getStoreTypeStatus(order.child.order_category, order.child.order_status)
                            .position
                        }%`,
                      }}
                    />
                  </div>
                  <div className="statusWrap">
                    {statusType.map((item, index) => (
                      <div
                        key={index}
                        className="statusDotWrap"
                        style={{
                          left: `${
                            getStoreTypeStatus(order.child.order_category, item).button_position
                          }%`,
                        }}>
                        {order.child.order_status === item && <div className="statusDot" />}
                        <p className="statusFont">
                          {getStoreTypeStatus(order.child.order_category, item).status_name}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isMobile && (
            <div className="stateButtonWrap">
              <button
                className={`stateButton cancel ${!checkProgress() && 'thin'}`}
                disabled={order.child.order_status === ORDER_CANCLE_STATUS}>
                <div className="buttonComment" onClick={() => setVisibleReject(true)}>
                  <h3>{'주문\n취소'}</h3>
                </div>
              </button>
              {checkProgress() && (
                <button className={`stateButton`} onClick={updateStatus}>
                  <div className="buttonComment">
                    <h3>
                      {
                        getStoreTypeStatus(order.child.order_category, order.child.order_status)
                          .button
                      }
                    </h3>
                  </div>
                </button>
              )}
            </div>
          )}
        </div>
      </Style>
    </Modal>
  );
};

export default SaleDetailModal;

const Style = styled.div`
  li::marker {
    color: #4dd2ae;
  }

  .modalWrapper {
    max-height: 80dvh;
    overflow: scroll;
    text-align: left;
  }
  .modalTitle {
    .headerBar {
      width: 44px;
      height: 5px;
      margin: 0 auto;
      border-radius: 10px;
      background: #4dd2ae;
    }
    h2 {
      margin-top: 22px;
      font-size: 24px;
      font-weight: 500;
      color: #555;
      text-align: center;
    }
  }

  /* modalContent */
  .modalContent {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 32px 10% 60px 10%;
    h4 {
      font-size: 16px;
      line-height: 20px;
      font-weight: 500;
      color: #a7a7a7;
    }
    h4.title {
      width: 70px;
      min-width: 70px;
      padding-bottom: 4px;
    }
    h4.subtitle {
      width: 75px;
      min-width: 75px;
    }

    .row.between {
      justify-content: space-between;
    }
    .row.gap {
      padding: 8px 0;
      gap: 20px;
    }
    h3 {
      font-weight: 500;
      color: #555555;
    }

    .between {
      position: relative;
      display: flex;
      justify-content: space-between;
      h4 {
        font-size: 16px;
        line-height: 24px;
        color: #555555;

        span {
          padding-right: 6px;
        }
      }
    }

    .menuWrap {
      padding-bottom: 8px;
      h3 {
        line-height: 24px;
        color: #555555;
      }

      h3.prdName {
        width: 60%;
        white-space: normal;
        word-break: break-all;
      }
      h3.prdQuantity {
        width: 10%;
        text-align: center;
      }
      h3.prdPrice {
        width: 30%;
        text-align: right;
      }
    }
  }

  .areaLine {
    width: 100%;
    height: 6px;
    background: #f7f7f7;
  }

  .statusBarWrap {
    width: 100%;
    margin-top: 40px;
    padding: 20px 20px;
    .statusBar {
      width: 100%;
      height: 12px;
      border-radius: 50px;
      overflow: hidden;
      background: #cfcfcf;
      position: relative;
    }
    .progressBar {
      height: 100%;
      width: 0;
      background: #4dd2ae;
      transition: width 0.3s ease-in-out;
    }
    .statusWrap {
      width: 100%;
      position: relative;
    }
    .statusDotWrap {
      width: 60px;
      position: absolute;
      .statusDot {
        position: absolute;
        top: -12px;
        width: 12px;
        height: 12px;
        border-radius: 100px;
        background: #40977f;
        z-index: 2;
      }
      .statusFont {
        position: absolute;
        left: 5%;
        padding-top: 4px;
        transform: translateX(-40%);
        font-size: 14px;
        line-height: 16px;
        font-weight: 400;
        white-space: nowrap;
        color: #999999;
        margin: 0 0;
      }
    }
  }

  @media (max-width: 900px) {
    .modalWrapper {
      height: 100dvh;
      max-height: 100dvh;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .modalBody {
      background: #fff;
      margin: 10px;
      padding: 24px 0 40px 0;
      border-radius: 10px;
    }

    .closeIcon {
      position: absolute;
      top: 30px;
      left: 20px;
    }

    .headerBar,
    .areaLine {
      display: none;
    }
    .prdWrap {
      display: flex;
      align-items: flex-start;
      padding: 10px 0;
      gap: 20px;
    }

    .modalTitle {
      position: relative;
      padding: 30px 0 6% 0;

      h2 {
        margin: 0;
      }
    }

    .modalContent {
      padding: 0 6%;
      color: #a7a7a7;
      h4.title {
        width: 70px;
        padding: 0;
      }
      h3 {
        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
        color: #555555;
      }

      .between {
        h4 {
          font-size: 14px;
          line-height: 20px;
          span {
            padding-right: 4px;
          }
        }
      }

      .menuWrap {
        width: 100%;
        h3 {
          line-height: 20px;
        }
        h3.prdName {
          width: 50%;
        }
        h3.prdQuantity {
          width: 10%;
        }
        h3.prdPrice {
          width: 40%;
        }
      }
    }

    .statusBarWrap {
      padding-top: 60px;
    }

    .stateButtonWrap {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4%;
      padding: 0 10px 20px 10px;
    }
    .stateButton {
      flex: 1;
      aspect-ratio: 4/3;
      max-height: 110px;
      border-radius: 15px;
      /* box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.25); */
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
      cursor: pointer;
      h3 {
        font-size: 24px;
        line-height: 30px;
        color: #ffffff;
        font-weight: 600;
      }
    }
    .stateButton.cancel {
      background: #979797;
      border-color: #979797;
      h3 {
        color: #fff;
      }
    }
    .stateButton.thin {
      width: 100%;
      max-height: 60px;
      margin-bottom: 50px;
    }
  }
`;
